import { LinkedServiceAdapter } from './linkedservice.adapter';
import { QuickbaseLinkedService } from '../../linkedservice/quickbase.linkedservice';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { Model } from '../../backendmodel';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(QuickbaseLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                userToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class QuickbaseLinkedServiceAdapter extends LinkedServiceAdapter<QuickbaseLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => QuickbaseLinkedService {
        return QuickbaseLinkedService;
    }

    protected model(): IModel {
        return QuickbaseLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: QuickbaseLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.QuickbaseLinkedService;
        properties.type = Metamodel.modelFor(QuickbaseLinkedService).name;
        properties.typeProperties = {
            url: this.valueToResource(linkedService, QuickbaseLinkedService.URL),
            userToken: parameterizablePasswordOrAKVtoSecretBase(linkedService, QuickbaseLinkedService.USER_TOKEN, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: QuickbaseLinkedService): Promise<QuickbaseLinkedService> {
        const properties = linkedServiceResource.properties as Model.QuickbaseLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(linkedService, QuickbaseLinkedService.URL, typeProperties.url);
        parameterizableSecretBaseToModel(linkedService, QuickbaseLinkedService.USER_TOKEN, typeProperties.userToken, this.context);
        return linkedService;
    }
}
